import { useState, useEffect } from "react"
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
// import { getTipoMultas } from "../MultasGrid/utils"
import { Accordion, DatePickerCustom, FormError, InputEntidad, InputLista, InputNumber, InputSubTasa, InputTasa, InputTipoMulta, Modal, FormLabel, Select } from "../../common"
import { useFormErrors } from "../../hooks/useFormErrors"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"
import { UNIDAD_VALORES } from '../../../views/TipoMultasView'
import { GetMeses } from "../../../utils/helpers"
import {TIPS} from "../../../consts/tips";


const MultaModal = (props) => {
    const [formValues, formHandle, resetForm, setFormValues] = useForm(props.item)
    // const [tipoMultas, setTipoMultas] = useState({})

    // useEffect(() => {
    //     getTipoMultas({
    //         onSuccess: data => {
    //             const newTipoMultas = {}
    //             data.forEach(item => newTipoMultas[item.id] = item)
    //             setTipoMultas(newTipoMultas)
    //         },
    //     })
    // }, [])

    // const onIdTipoMultaChange = (event) => {
    //     setFormValues(prev => ({ ...prev, idUnidadValor: tipoMultas[event.target.value].idUnidadValor }))
    //     formHandle(event)
    // } 


    
    const onAccept = () => {
        if (!validate()) return;

        formValues.idUnidadValor = selectedTipoMulta?.idUnidadValor ?? 0;
        
        props.onAccept(formValues)
    }

    function getErrors() {
        const errors = {};

        if (formValues.idTipoMulta <= 0) errors.idTipoMulta = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idTipoMulta > 0 && !selectedTipoMulta) errors.idTipoMulta = 'No se pudo resolver el tipo de multa';
        if (formValues.valor <= 0) errors.valor = 'Ingresá un número mayor a cero';
        if (formValues.periodo.length <= 0) errors.periodo = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.mes <= 0) errors.mes = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.fecha === null) errors.fecha = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (formValues.idTasa <= 0) errors.idTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idSubTasa <= 0) errors.idSubTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    function getFormatErrors() {
        const errors = {};

        if (props.mode === 'view' || !selectedTipoMulta || formValues.idTipoMulta <= 0 || formValues.valor <= 0) return errors;
        if (formValues.valor > selectedTipoMulta.valorHasta) errors.valor = `Supera el máximo del tipo (${selectedTipoMulta.valorHasta})`;
        else if (formValues.valor < selectedTipoMulta.valorDesde) errors.valor = `Menor al mínimo del tipo (${selectedTipoMulta.valorDesde})`;

        return errors;
    }

    // const selectedTipoMulta = tipoMultas[formValues.idTipoMulta] ?? {}
    const [selectedTipoMulta, setSelectedTipoMulta] = useState(null)

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

    return (
        <Modal
            onEscape={props.onCancel}
            show
            title='Multa'
            tipName={TIPS.NAME.MODALS.MULTA_MODAL}
            body={(
                <Accordion title="Datos de la multa" startOpen={true}>
                    <div className='row form-basic'>
                        <div className="col-12 col-md-6">
                            <FormLabel htmlFor="idTipoMulta" required>Tipo de multa</FormLabel>
                            <InputEntidad
                                name="idTipoMulta"
                                placeholder=""
                                tipName={TIPS.NAME.MODALS.TIPO_MULTA_MODAL}
                                className={`form-control ${errorOf('idTipoMulta') ? 'is-invalid' : ''}`}
                                value={ formValues.idTipoMulta }
                                onChange={ formHandle }
                                disabled={ props.mode === 'view' }
                                title="Tipo de Multa"
                                entidad="TipoMulta"
                                filter={(row) => row.idTipoTributo === props.idTipoTributo}
                                onUpdate={({target}) => setSelectedTipoMulta(target.row ?? null)}
                            />
                            <FormError message={errorOf('idTipoMulta')} />
                            {/* <InputTipoMulta
                                idTipoTributo={props.idTipoTributo}
                                value={formValues.idTipoMulta}
                                onChange={onIdTipoMultaChange}
                                disabled={ props.mode === 'view' }
                            /> */}
                        </div>
                        <div className="col-6 col-md-3">
                            <label htmlFor="idUnidadValor" className="form-label">Unidad de valor</label>
                            <InputLista
                                lista="UnidadValor"
                                name="idUnidadValor"
                                placeholder=""
                                className="form-control"
                                value={selectedTipoMulta?.idUnidadValor ?? 0}
                                disabled
                            />
                            <FormError />
                        </div>
                        <div className="col-6 col-md-3">
                            <FormLabel htmlFor="valor" required>Valor</FormLabel>
                            <InputNumber
                                name="valor"
                                placeholder=""
                                className={`form-control ${errorOf('valor') ? 'is-invalid' : ''}`}
                                value={formValues.valor}
                                onChange={formHandle}
                                precision={selectedTipoMulta?.idUnidadValor === UNIDAD_VALORES.UF ? 0 : 2}
                                disabled={ props.mode === 'view' }
                                /* validation={value => value >= selectedTipoMulta.valorDesde && value <= selectedTipoMulta.valorHasta} */
                            />
                            <FormError message={errorOf('valor')} />
                        </div>

                        <div className="col-12 col-md-6">
                            <FormLabel htmlFor="idTasa" required>Tasa</FormLabel>
                            <InputTasa
                                name="idTasa"
                                placeholder=""
                                className={`form-control ${errorOf('idTasa') ? 'is-invalid' : ''}`}
                                value={ formValues.idTasa }
                                onChange={ formHandle }
                                disabled={ props.mode === 'view' }
                            />
                            <FormError message={errorOf('idTasa')} />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormLabel htmlFor="idSubTasa" required>Sub tasa</FormLabel>
                            <InputSubTasa
                                name="idSubTasa"
                                placeholder=""
                                className={`form-control ${errorOf('idSubTasa') ? 'is-invalid' : ''}`}
                                value={ formValues.idSubTasa }
                                onChange={ formHandle }
                                disabled={ props.mode === 'view' }
                                idTasa={formValues.idTasa}
                            />
                            <FormError message={errorOf('idSubTasa')} />
                        </div>

                        <div className="col-6 col-md-3">
                            <FormLabel htmlFor="periodo" required>Período</FormLabel>
                            <input
                                name="periodo"
                                type="text"
                                placeholder=""
                                className={`form-control ${errorOf('periodo') ? 'is-invalid' : ''}`}
                                value={formValues.periodo}
                                onChange={formHandle}
                                disabled={ props.mode === 'view' }
                            />
                            <FormError message={errorOf('periodo')} />
                        </div>
                        <div className="col-6 col-md-3">
                            <FormLabel htmlFor="mes" required>Mes</FormLabel>
                            <Select
                                name="mes"
                                className={`form-control ${errorOf('mes') ? 'is-invalid' : ''}`}
                                value={ formValues.mes }
                                options={GetMeses().map(item => ({value: item.key, label: item.name}))}
                                onChange={formHandle}
                                disabled={ props.mode === 'view' }
                            />
                            <FormError message={errorOf('mes')} />
                        </div>
                        <div className="col-6 col-md-3">
                            <FormLabel htmlFor="fecha" required>Fecha</FormLabel>
                            <DatePickerCustom
                                name="fecha"
                                placeholder=""
                                className={`form-control ${errorOf('fecha') ? 'is-invalid' : ''}`}
                                value={formValues.fecha}
                                disabled
                            />
                            <FormError message={errorOf('fecha')} />
                        </div>
                    </div>
                </Accordion>
            )}
            
            footer={<>
                {props.mode !== 'view' && (
                    <>
                    <button className="btn btn-outline-primary" data-dismiss="modal" onClick={props.onCancel}>Cancelar</button>
                    <button className="btn btn-primary" data-dismiss="modal" onClick={onAccept}>Aceptar</button>
                    </>
                )}
                {props.mode == 'view' && ( 
                    <div className="width-100p f-align">
                        <button className="btn back-button" data-dismiss="modal" onClick={props.onCancel}>Volver</button>
                    </div>
                )}
            </>}
        />
    )
}

export default MultaModal
